// removed by extract-text-webpack-plugin
module.exports = {"raised":"style__raised___1YO8U","flat":"style__flat___2UJfS","floating":"style__floating___17YiZ","toggle":"style__toggle___2n01i","icon":"style__icon___2GNOS","mini":"style__mini___JjRxL","neutral":"style__neutral___iXLge","inverse":"style__inverse___2NYEz","primary":"style__primary___2QrZv","accent":"style__accent___3EOvj"};


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-toolbox/lib/button/style.scss
 ** module id = 122
 ** module chunks = 0
 **/